const initialState = {
    token: ""
}

export default function reducer(state = initialState,action){
    switch(action.type){
        case 'ADD_TOKEN':
            return {...state,token:action.payload};

        case 'REMOVE_TOKEN':
            return{...state,token:""};
        default:
            return state;
    }
}